import { message, Tooltip } from "antd";
import {
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Badge } from "V2.0/common/badge";
import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { languages } from "./languages";

const genders = {
  male: "Male",
  female: "Female",
};

function VoicesSearchResultsTable(props) {
  const { voices, onAdd, onLoadMore } = props;
  const { data, isLoading, hasMore } = voices;

  if (isLoading && voices.data.length === 0) {
    return (
      <div>
        <Table>
          <TableBody>
            {[...Array(7)].map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <div className="w-[400px] h-20">
                    <div className="flex flex-col gap-y-2">
                      <div className="w-56 h-2 animate-pulse bg-gray-300" />
                      <div className="flex gap-x-2">
                        <div className="w-8 h-2 animate-pulse bg-gray-300" />
                        <div className="w-8 h-2 animate-pulse bg-gray-300" />
                      </div>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="w-72 h-12 rounded-full animate-pulse bg-gray-100" />
                </TableCell>
                <TableCell>
                  <div className="flex gap-x-2">
                    <div className="w-16 h-10 rounded-md animate-pulse bg-gray-200" />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full">
      <Table>
        {data.length > 0 && (
          <TableBody>
            {data.map((voice) => {
              const { voice_id, name, gender, language, preview_url } = voice;
              return (
                <TableRow
                  key={voice_id}
                  className="hover:bg-gray-50 cursor:pointer"
                >
                  <TableCell className="">
                    <div className="flex flex-col gap-y-1">
                      <div className="flex items-center gap-x-4">
                        <p className="text-md font-semibold truncate max-w-[300px]">
                          {name}
                        </p>
                      </div>
                      <div className="flex items-start gap-x-2 mb-2">
                        <p className="text-gray-400">{voice_id}</p>
                        <Tooltip title="Copy Voice ID">
                          <CopyToClipboard text={voice_id}>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                message.success("Copied");
                              }}
                            >
                              <DocumentDuplicateIcon className="size-4 text-gray-500 cursor-pointer hover:text-gray-700" />
                            </div>
                          </CopyToClipboard>
                        </Tooltip>
                      </div>
                      <div className="flex gap-x-2">
                        <Badge>{genders[gender]}</Badge>
                        <Badge>{languages[language]}</Badge>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <audio controls className="mt-2">
                      <source src={preview_url} type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-x-2 items-center">
                      {/* <CopyToClipboard text={voice_id}>
                        <Button
                          outline
                          onClick={() => message.success("VoiceID copied")}
                        >
                          <DocumentDuplicateIcon /> ID
                        </Button>
                      </CopyToClipboard> */}
                      <Button outline onClick={() => onAdd(voice)}>
                        <PlusIcon />
                        Add
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
            {isLoading && (
              <TableRow>
                <TableCell>
                  <div className="w-[350px] h-20">
                    <div className="flex flex-col gap-y-2">
                      <div className="w-56 h-2 animate-pulse bg-gray-300" />
                      <div className="flex gap-x-2">
                        <div className="w-8 h-2 animate-pulse bg-gray-300" />
                        <div className="w-8 h-2 animate-pulse bg-gray-300" />
                      </div>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="w-72 h-12 rounded-full animate-pulse bg-gray-100" />
                </TableCell>
                <TableCell>
                  <div className="flex gap-x-2">
                    <div className="w-16 h-10 rounded-md animate-pulse bg-gray-200" />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        )}
      </Table>
      {hasMore && (
        <div
          className="w-full p-4 flex items-center justify-center border-b border-gray-100"
          onClick={(e) => {
            e.stopPropagation();
            onLoadMore();
          }}
        >
          <p className="text-blue-600 cursor-pointer">Load more voices</p>
        </div>
      )}
    </div>
  );
}

export { VoicesSearchResultsTable };
